import { emptyFn } from "../../framework/core/util";
import { settings } from "../core/settings";

/*
* dataSource
* Wrapper for kendo.data.DataSource
*
* All kendo datasource options are accepted
*
*
* Defaults:
* type = "odata"
* schema = data.d.results
* pageSize = 10
* serverFiltering = true
* serverPaging = true
* serverSorting = true
* transport = Auth Token and JSON types
* error = log error to console
*
*/
export function dataSource(options) {
    var url = settings.baseUrl + options.url;

    options.type = options.type || "odata",
    options.schema = options.schema || {
        data: function (data) {
            return data.d.results || [];
        },
        errors: function (response) {
            return response.error;
        },
        model: {
            id: "Id"
        }
    };
    options.sort = options.sort || [];
    options.pageSize = options.pageSize || 10;
    options.serverFiltering = options.serverFiltering || true;
    options.serverPaging = options.serverPaging || true;
    options.serverSorting = options.serverSorting || true;

    if (options.transport) {
        if (options.transport.read) {
            options.transport.read.contentType = options.transport.read.contentType || "application/json";
            options.transport.read.dataType = options.transport.read.dataType || "json";
        }
        if (options.transport.create) {
            options.transport.create.contentType = options.transport.create.contentType || "application/json";
            options.transport.create.dataType = options.transport.create.dataType || "json";
        }
        if (options.transport.update) {
            options.transport.update.contentType = options.transport.update.contentType || "application/json";
            options.transport.update.dataType = options.transport.update.dataType || "json";
            options.transport.update.type = options.transport.update.type || "PATCH";
        }
        if (options.transport.destroy) {
            options.transport.destroy.contentType = options.transport.destroy.contentType || "application/json";
            options.transport.destroy.dataType = options.transport.destroy.dataType || "json";
        }
    }

    options.transport = options.transport || {
        read: {
            url: url,
            contentType: "application/json",
            dataType: "json"
        },
        update: {
            url: url,
            contentType: "application/json",
            dataType: "json",
            type: "PATCH"
        }
    };

    options.batch = true;

    if (options.parent) {
        let requestStart = options.requestStart || emptyFn;
        options.requestStart = function (e) {
            let parentData = this.options.parent.data("kendoGrid"),
                content;
            if (parentData) {
                content = parentData.element.find(".k-grid-content");

                content.stop();
                content.scrollTop(0);
                content.css({"overflow-x": "hidden", "overflow-y": "hidden" });

                if (content.find(".k-grid-norecords").length > 0) {
                    content.find(".k-grid-norecords").remove();
                    content.prepend(`<div class="k-loading-mask" style="width: 100%; height: 100%; top: 10px; left: 0px;"><div class="k-loading-image"></div></div>`);
                }
            }
            requestStart.apply(this, [e]);
        };

        let requestEnd = options.requestEnd || emptyFn;
        options.requestEnd = function (e) {
            let data = this.options.parent.data("kendoGrid"),
                content = data ? data.element.find(".k-grid-content") : null;
            if (content) {
                content.stop();
                content.css({"overflow-x": "auto", "overflow-y": "scroll" });
            }

            requestEnd.apply(this, [e]);
        };
    }

    var retryCount = 0;
    var errorFn = options.error || emptyFn;
    options.error = function (e) {
        if (retryCount > 3) {
            retryCount = 0;
            errorFn.apply(this, [e]);
            return;
        }

        if (e.xhr.status == 502) {
            retryOnError();
        } else {
            errorFn.apply(this, [e]);
        }
    };

    var dsType = options.dsType || "DataSource";

    var ds = new kendo.data[dsType](options);

    let retryOnError = function () {
        console.log("502 Detected");
        $.wait(2000 * retryCount).then(function () {
            retryCount++;
            ds.fetch();
        });
    };

    return ds;
}
